"use client";

import { ACCESS_COOKIE } from "./config";

/** Read access JWT from the readable cookie (browser only). */
export function getAccessTokenClient(): string | null {
  if (typeof document === "undefined") return null;

  const prefix = `${ACCESS_COOKIE}=`;
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(prefix));

  if (!match) return null;
  return decodeURIComponent(match.slice(prefix.length));
}
